import { render, staticRenderFns } from "./BiddingProductCompound.vue?vue&type=template&id=210ee68e&scoped=true&"
import script from "./BiddingProductCompound.vue?vue&type=script&lang=js&"
export * from "./BiddingProductCompound.vue?vue&type=script&lang=js&"
import style0 from "./BiddingProductCompound.vue?vue&type=style&index=0&id=210ee68e&lang=scss&scoped=true&"
import style1 from "./BiddingProductCompound.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ee68e",
  null
  
)

export default component.exports